import {
  MetroEkb16,
  MetroKazan16,
  MetroMoscow16,
  MetroNn16,
  MetroNovosib16,
  MetroSamara16,
  MetroSpb16,
} from '@cian/ui-kit/icons';
import * as React from 'react';

import { UndergroundIconWrapper } from '../../../components/UndergroundIconWrapper';
import { useOfferContext } from '../../../context';
import { ELocationTypeId, IAddress } from '../../../types/offer';

export function UndergroundIconContainer() {
  const { offer, underground } = useOfferContext();

  const id = React.useMemo(() => {
    const { id } =
      (offer.geo && offer.geo.address.find(item => item.locationTypeId === ELocationTypeId.City)) || ({} as IAddress);

    return id;
  }, [offer.geo]);

  const color = React.useMemo(() => (underground && `#${underground.lineColor}`) || undefined, [underground]);

  const icon = React.useMemo(() => {
    switch (id) {
      case 2:
        return <MetroSpb16 color="current_color" />;
      case 4743:
        return <MetroEkb16 color="current_color" />;
      case 4777:
        return <MetroKazan16 color="current_color" />;
      case 4897:
        return <MetroNovosib16 color="current_color" />;
      case 4966:
        return <MetroSamara16 color="current_color" />;
      case 4885:
        return <MetroNn16 color="current_color" />;
      default:
        return <MetroMoscow16 color="current_color" />;
    }
  }, [id]);

  if (!underground) {
    return null;
  }

  return <UndergroundIconWrapper color={color}>{icon}</UndergroundIconWrapper>;
}
